import api from './api'

const resource = '/apps/employees'

export default {
    get(outlet, position) {
        return api.get(`${resource}?outlet_code=${outlet}&position=${position}`);
    },
    getEmployee(npp) {
        return api.get(`${resource}/${npp}`);
    }
}